const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrugDosage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.13,13.725l1.613-1.65 c0.494-1.098-0.182-1.759-0.182-1.759c-0.9-0.989-1.998-0.477-1.998-0.477l-4.125,4.013c0,0-0.752,0.953,0.146,1.998 c0,0,0.494,0.625,1.557,0.496"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 11.417,
    y1: 11.91,
    x2: 13.323,
    y2: 13.816
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 14.03,
    cy: 14.943,
    rx: 2.942,
    ry: 1.182
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M11.088,15.025v1.385 c0,0.65,1.317,1.182,2.94,1.182c1.625,0,2.943-0.531,2.943-1.182v-1.467"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 12.86,
    y1: 16.014,
    x2: 15.28,
    y2: 13.885
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.083,13.871c0,0-0.947,0.922,0.056,1.73"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M11.632,11.719V7.278 c0-0.565-0.458-1.023-1.024-1.023L10.486,6.24V4.888"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M4.769,4.888V6.24L4.677,6.254 c-0.566,0-1.025,0.458-1.025,1.023v8.833c0,0.566,0.459,1.023,1.025,1.023h5.931c0.269,0,0.513-0.104,0.695-0.271"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.981,4.893V3.516 c0-0.565-0.458-1.024-1.024-1.024H5.32c-0.565,0-1.023,0.458-1.023,1.024v1.377H10.981z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 4.652,
    y1: 3.434,
    x2: 4.652,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 5.025,
    y1: 3.434,
    x2: 5.025,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 5.398,
    y1: 3.434,
    x2: 5.398,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 5.771,
    y1: 3.434,
    x2: 5.771,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 6.144,
    y1: 3.434,
    x2: 6.144,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 6.518,
    y1: 3.434,
    x2: 6.518,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 6.892,
    y1: 3.434,
    x2: 6.892,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 7.265,
    y1: 3.434,
    x2: 7.265,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 7.638,
    y1: 3.434,
    x2: 7.638,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 8.011,
    y1: 3.434,
    x2: 8.011,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 8.385,
    y1: 3.434,
    x2: 8.385,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 8.757,
    y1: 3.434,
    x2: 8.757,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 9.132,
    y1: 3.434,
    x2: 9.132,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 9.505,
    y1: 3.434,
    x2: 9.505,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 9.878,
    y1: 3.434,
    x2: 9.878,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 10.251,
    y1: 3.434,
    x2: 10.251,
    y2: 4.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 10.625,
    y1: 3.434,
    x2: 10.625,
    y2: 4.43
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 4.298,
    y1: 4.59,
    x2: 10.988,
    y2: 4.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 7.641,
    cy: 11.561,
    r: 2.448
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "9.299,10.861 8.33,10.861  8.33,9.892 6.998,9.892 6.998,10.861 6.028,10.861 6.028,12.193 6.998,12.193 6.998,13.162 8.33,13.162 8.33,12.193  9.299,12.193  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugDosage);
export default __webpack_public_path__ + "static/media/drug_dosage.7c496bf08e88c71f687620bcba7c5193.svg";
export { ForwardRef as ReactComponent };